import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class SatesListService extends ApiService {
  public getStatesList(): Observable<any> {
    return this.get<any>(ROUTES.STATE_LIST, {});
  }

  public getForeignStatesList(country: string): Observable<any> {
    const params = { country }
    return this.get<any>(ROUTES.STATE_LIST_FOREIGN, { params });
  }

  public getAddressAttribute(): Observable<any> {
    return this.get<any>(ROUTES.ADDRESS_ATTRIBUTE, {});
  }
}
